import { HttpService } from '../https.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export type OtherProduct = 'vitagist' | 'dilite' | 'content' | 'connect' | 'regswatch';

@Injectable({
  providedIn: 'root'
})
export class OtherProductsService {

  constructor(private httpService: HttpService) {}


  getVitagistConsumers(): Observable<any> {
    return this.httpService.sendReGetRequest('/consumer') as Observable<any>;
  }

  getDiliteProfessionals(): Observable<any> {
    return this.httpService.sendHealthGetRequest('/professional/search/health') as Observable<any>;
  }

  getContentProfessionals(): Observable<any> {
    return this.httpService.sendRePostRequest('/professional/search/content', {}) as Observable<any>;
  }

  getConnectProfessionals(): Observable<any> {
    return this.httpService.sendRePostRequest('/professional/search/connect', {}) as Observable<any>;
  }

  getRegswatchProfessionals(): Observable<any> {
    return this.httpService.sendRePostRequest('/professional/search/regswatch', {}) as Observable<any>;
  }
}